import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../../admin/auth.service';
import Swal from 'sweetalert2';
import { UsersService } from '../../services/users.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

  public user$: Observable <any> = this._auth._authfb.user;
  detailUser;
  autorizacion = false;

  showMenu = false;

  empresa = environment.empresa;

  constructor(
    public _auth: AuthService,
    private _users: UsersService
  ) { }

  ngOnInit() {
      this.user$.subscribe( async data => {
        this.detailUser = await data;
        if(!data?.email){
          return;
        }else{
          //this.autorizacion = false;
          this._users.getAuthorization(data.email, 'editor').then( result => {
            this.autorizacion = result;
          });
        }
      });
  }

  logout(){
    this.autorizacion = false;
    this.onLinkClick();
    this._auth.logout();
    Swal.fire({
      position: 'center',
      icon: 'success',
      title: 'Sesión Cerrada',
      showConfirmButton: false,
      timer: 1500
    })
  }

  onLinkClick(){
    window.scroll({
      top: 0,
      left: 100,
      behavior: 'smooth'
    }); 
    this.showMenu = !this.showMenu;
  }

  getAuthorization(){
    return this.autorizacion;
  }
}
